import { separator } from "../../utils/paymentMethodUtils";
import { AdminInvoicesUpfront } from "./AdminPaymentRecaudo.interface";

export const ConvertResponseAdminPaymentRecaudo = (
  res: AdminInvoicesUpfront
) => {
  const data = res.invoices.map((invoice) => {
    const currencyPayment = separator(
      invoice.payment_currency === "usd"
        ? invoice.sales_invoice_total.usd
        : invoice.sales_invoice_total.pen
    );
    const dollarSol = invoice.payment_currency === "usd" ? "DÓLARES" : "SOLES";
    return {
      invoiceId: invoice.invoice_id,
      invoiceNum: invoice.invoice_num,
      agentName: invoice.agent_name,
      salesInvoiceTotal: invoice.sales_invoice_total,
      paymentCurrency: invoice.payment_currency,
      volantes: invoice.volantes_by_invoice,
      differentialStatus: invoice.differential_status,
      cashbackStatus: invoice.cashback_status,
      paymentStatus: invoice.payment_status,
      warningComment: invoice.warning_comment,
      vouchers: invoice.vouchers,
      compensationDetail: invoice.compensation_detail,
      quotations: invoice.quotations,
      dateInvoice: invoice.updated_at,
      bankDetail: invoice.upfront_payment_detail,
      upfrontDetail: invoice.upfront_detail,
      upfrontBankInformationComment: invoice?.upfront_bank_information_comment,
      currencyPayment,
      dollarSol,
    };
  });

  return {
    data,
    num_pages: res.num_pages,
    page_size: res.page_size,
    count: res.count,
    page: res.page,
  };
};
